import React from 'react'
import { css } from '@emotion/core'
import { LabelTooltip, H2 } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'
import { MenuNewWindow } from '@fs/zion-icon'

const GatedRecordDetailsLink = ({ recordPermissions, selectedPersonId, heading }) => {
  const [t] = useTranslation()

  return (
    <H2 size="H5">
      <>
        {!recordPermissions && <>{heading}</>}
        {recordPermissions && (
          <LabelTooltip
            label={t('view-index.given-name.link.tool-tip', 'View Record Details Page')}
            target={
              <Link
                external
                wayfinding
                to={`/ark:/61903/${selectedPersonId}`}
                onClick={(e) => {
                  e.preventDefault()
                  window.open(`/ark:/61903/${selectedPersonId}`, '_blank')
                }}
              >
                {heading}
                <span
                  css={css`
                    position: relative;
                    top: 2px;
                    inset-inline-start: 2px;
                  `}
                >
                  <MenuNewWindow size="xs" />
                </span>
              </Link>
            }
          />
        )}
      </>
    </H2>
  )
}
export default GatedRecordDetailsLink
